import { render, staticRenderFns } from "./FMDConcernElements.vue?vue&type=template&id=b90044d2&"
import script from "./FMDConcernElements.vue?vue&type=script&lang=js&"
export * from "./FMDConcernElements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports